import { Button } from '../../components';
import React from 'react';
import { VerionManagementDetail } from '../../services';
import warning from '../../assets/svg/warning.svg';
import  '../Modal/Modal.global.scss';

interface Props {
  handleModalClose: any;
  id: any;
  fetchAdminList: any;
  setShowOverlay: any;
}

const VersionManagementDelete: React.FC<Props> = (props: Props) => {
  const {
    handleModalClose,
    id,
    fetchAdminList,
    setShowOverlay,
  } = props;

  const [deleted, setDeleted] = React.useState(false);
  const deleteVersionService = () => {
    setShowOverlay(true);
    VerionManagementDetail.deleteVersionDetails({
      versionId: id
    }).then(() => {
      setShowOverlay(false);
      setDeleted(true);
    });
  };

  return (
    <>
      {!deleted ? (
        <>
          <img src={warning} alt="warning" />
          <h2>
            Delete New Version
          </h2>
          <p>
            Are you sure you want to delete this Version?
          </p>
          <div className="modalButtonWrapper">
            <Button onClick={handleModalClose}>No</Button>
            <Button intent="danger" onClick={deleteVersionService}>Yes</Button>
          </div>
        </>
      ) : (
        <>
          <h3>
            Version deleted successfully !
          </h3>
          <Button onClick={() => {
            handleModalClose();
            fetchAdminList({
              page: 1,
              rowsPerPage: 10,
            });
          }}
          >
            Ok
          </Button>
        </>
      )}

    </>
  );
};

export default VersionManagementDelete;
